export async function hashChallenge(challenge: string): Promise<string> {
  const cbytes = decode(challenge);
  const chash = await hash(cbytes);
  return encode(chash);
}

// decode expects a Base64URL-encoded string with no padding. URL-STD conversion courtesy of https://jsfiddle.net/magikMaker/7bjaT/ (minus the bugs)
export function decode(src: string): Uint8Array {
  const remainder = src.length % 4;
  if (remainder > 0) src += '='.repeat(4 - remainder);
  const std = src.replace(/-/g, '+').replace(/_/g, '/');
  const bin = atob(std);
  let bytes = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) {
    bytes[i] = bin.charCodeAt(i);
  }
  return bytes;
}

export async function newVerifier(): Promise<Uint8Array> {
  let bytes = new Uint8Array(16);
  bytes = crypto.getRandomValues(bytes);
  return await hash(bytes);
}

async function hash(value: Uint8Array): Promise<Uint8Array> {
  const buf = await crypto.subtle.digest('SHA-256', value);
  return new Uint8Array(buf);
}

// encode returns a Base64URL-encoded string with no padding. STD-URL conversion courtesy of https://jsfiddle.net/magikMaker/7bjaT/ (minus the bugs)
export function encode(src: Uint8Array): string {
  let str = '';
  for (var i = 0; i < src.length; i++) {
    str += String.fromCharCode(src[i]);
  }
  const std = btoa(str);
  return std.replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
}

export async function hashVerifier(verifier: Uint8Array): Promise<string> {
  const challenge = await hash(verifier);
  return encode(challenge);
}
